import { createRoute } from '../utils/routing.util';

const routes = {
  root: createRoute('/'),
  trading: createRoute('/trading', 'common.menu.trading'),
  accounts: createRoute('/accounts', 'common.menu.accounts'),
  accountOpen: createRoute('/account/create', 'common.menu.accounts'),
  accountOperations: createRoute(
    '/accounts/:account',
    'common.menu.accountsOperations'
  ),
  operationDetails: createRoute(
    '/accounts/:account/:positionId/:dealId',
    'common.menu.operationDetails'
  ),
  operations: createRoute('/operations', 'common.menu.depositsWithdraw'),
  instruments: createRoute('/instruments', 'common.menu.instruments'),
  ewallet: createRoute('/ewallet', 'common.menu.eWallet'),
  bonus: createRoute('/bonus', 'common.menu.bonus'),
  partnership: createRoute('/partnership', 'common.menu.partnership'),
  createUTM: createRoute('/partnership/create', 'common.menu.createUTM'),
  faq: createRoute('/faq', 'common.menu.FAQ'),
  analytics: createRoute('/analytics', 'common.menu.analytics'),
  profile: createRoute('/profile', 'common.menu.profile'),
  postPayment: createRoute('/payment-redirect', 'common.menu.profile'),
  kyc: createRoute('/kyc', 'common.menu.kyc'),
  auth: {
    login: createRoute('/login', 'common.menu.login'),
    postLogin: createRoute('/signin', 'common.menu.postLogin'),
    postRegistration: createRoute('/singup', 'common.menu.postRegistration'),
    confirmPassReset: {
      postSent: createRoute('/confirm-email', 'common.menu.postSent'),
      doAction: createRoute('/confirm-email/action', 'common.menu.postSent'),
      postConfirm: createRoute(
        '/confirm-email/success',
        'common.menu.postSuccess'
      ),
    },
    confirmEmail: {
      postSent: createRoute('/verify-email', 'common.menu.postSent'),
      doAction: createRoute('/verify-email/action', 'common.menu.postSent'),
      postConfirm: createRoute(
        '/verify-email/success',
        'common.menu.postSuccess'
      ),
    },
  },
  external: {
    login: createRoute('/login-ext', 'common.menu.loginExt'),
    registration: createRoute('/signup-ext', 'common.menu.registrationExt'),
    analytics: createRoute('/analytics-ext', 'common.menu.analyticsExt'),
    tradingSessionsMap: createRoute(
      '/map-ext',
      'common.menu.tradingSessionsMapExt'
    ),
  },
  wizard: createRoute('/wizard', 'common.menu.wizard'),
  copyTrading: createRoute('/copy-trading', 'common.menu.copyTrading'),
  rewards: createRoute('/rewards', 'common.menu.rewards'),
  __dev: {
    designSystem: createRoute('/design-system', 'Design system'),
  },
};

export const ignoreListForPwaInstallation = [
  routes.auth.login.path,
  routes.auth.postLogin.path,
  routes.auth.postRegistration.path,
  routes.auth.confirmPassReset.postSent.path,
  routes.auth.confirmPassReset.doAction.path,
  routes.auth.confirmPassReset.postConfirm.path,
  routes.auth.confirmEmail.postSent.path,
  routes.auth.confirmEmail.doAction.path,
  routes.auth.confirmEmail.postConfirm.path,
  routes.external.login.path,
  routes.external.registration.path,
  routes.external.analytics.path,
  routes.external.tradingSessionsMap.path,
];

export const INITIAL_URL_IGNORELIST = [routes.auth.login.path];

export const FORCE_REDIRECT_TO_SIGNUP = [routes.wizard.path];

export const AUTHORIZED_ROUTES_WL = [
  routes.external.registration,
  routes.external.login,
  routes.external.analytics,
  routes.external.tradingSessionsMap,
  routes.auth.login,
  routes.auth.postLogin,
  routes.auth.postRegistration,
  routes.auth.confirmEmail.postSent,
  routes.auth.confirmEmail.doAction,
  routes.auth.confirmEmail.postConfirm,
  routes.auth.confirmPassReset.postSent,
  routes.auth.confirmPassReset.doAction,
  routes.auth.confirmPassReset.postConfirm,
  routes.postPayment,
].map((el) => el.path);

export const NO_CHAT_ROUTES = [
  routes.external.registration,
  routes.external.login,
  routes.external.analytics,
  routes.external.tradingSessionsMap,
  routes.auth.postLogin,
  routes.auth.postRegistration,
  routes.auth.confirmEmail.doAction,
  routes.auth.confirmEmail.postConfirm,
  routes.auth.confirmPassReset.doAction,
  routes.auth.confirmPassReset.postConfirm,
].map((el) => el.path);

export default routes;
